/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { SlateUpdateInfo, TopStacksModel } from "./queryTypes";
import { FullSlateResponse, SitesResponse, SlateResponse, SportsResponse } from "../store/types";

export const useGetSlates = (app: string, disable: boolean) => {
  const params = {
    app,
  }
  return useQuery<FullSlateResponse, Error>({
    queryKey: [`slateInfo-${app}`],
    queryFn: async () => {
      const slates: SlateResponse[] = await fetch(`${process.env.REACT_APP_API_URL}/api/contests/getPreContestSlateInfo?` + new URLSearchParams(params)).then(res => res.json());
      const sites = slates?.map(x => x.site).filter((v, i, a) => a.indexOf(v) === i).map(x => ({ site: x } as SitesResponse));
      const sports = slates?.map(x => x.sport).filter((v, i, a) => a.indexOf(v) === i).map(x => ({ sport: x } as SportsResponse));
      return {
        slates,
        sites,
        sports
      } as FullSlateResponse;
    },
    refetchOnWindowFocus: false,
    enabled: !disable,
  })
};

export const useGetSlateInfoQuery = (slateId: string, disable: boolean = false) => {
    const params = {
      slateId,
    };

    return useQuery<SlateUpdateInfo, Error>({
      queryKey: [`lambaStatus-${slateId}`],
      queryFn: () => {
        const data: Promise<SlateUpdateInfo> = fetch(`${process.env.REACT_APP_API_URL}/api/slatedata/slateUpdateInfo?` + new URLSearchParams(params)).then(res => res.json());
        return data;
      },
      refetchInterval: 60 * 60 * 1000,
      enabled: !disable
    });
  }

export const useGetTopStacks = (sport: string, site: string, disable: boolean = false) => {
    const params = {
      sport,
      site,
    };

    return useQuery<TopStacksModel[], Error>({
      queryKey: [`topStacks-${sport}-${site}`],
      queryFn: async () => {
        const data: TopStacksModel[] = await fetch(
          `${process.env.REACT_APP_API_URL}/api/slatedata/topStacks?` + new URLSearchParams(params)
        ).then(res => res.json());
        return data;
      },
      refetchOnWindowFocus: false,
      enabled: !disable
    });
  }